import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '.';

// This has to be in a separate file or the bundling breaks.
export const createAppThunk = createAsyncThunk.withTypes<{
    state: RootState;
}>();
